import { createActionTypes } from '../../../util/createLifeomicActionTypes';

const actions = createActionTypes(['SET_SELECTED_USAGE_CYCLE']);

export default {
  ...actions,
};
